import Vue from 'vue'
import VueRouter from 'vue-router'
import {auth} from '@/plugins/firebase'
import store from '../store'

Vue.use(VueRouter)

const ROUTE_PATHS = Object.freeze({
    HOME: '/',
    LOGIN: '/login',
    AUTH: '/auth',
    QUESTIONS: '/questions',
    QUIZ_RESULTS: '/quiz-results',
    REPORTS: '/reports',
    USERS_MANAGEMENT: '/users-management',
    PRODUCT_SCORE: '/product-score',
    RESULT_MANAGEMENT: '/result-management',
    ORDERS: '/orders',
    PACKAGING: '/packaging',
})

const routes = [
    {
        path: ROUTE_PATHS.HOME,
        name: 'Dashboard',
        component: () => import(/* webpackChunkName: "Dashboard" */ '@/views/dashboard/Dashboard.vue'),
        meta: {
            requiresAuth: true
        },
        children: [
            {
                path: ROUTE_PATHS.QUESTIONS,
                name: 'Question',
                component: () => import(/* webpackChunkName: "Question" */ '@/views/dashboard/Questions.vue'),
                meta: {
                    requiresAuth: true,
                    requiresAdmin: true
                },
                childs: []
            },
            {
                path: ROUTE_PATHS.QUIZ_RESULTS,
                name: 'QuizResults',
                component: () => import(/* webpackChunkName: "QuizResults" */ '@/views/dashboard/QuizResults.vue'),
                meta: {
                    requiresAuth: true,
                    requiresAdmin: true
                },
                childs: []
            },
            {
                path: ROUTE_PATHS.REPORTS,
                name: 'Reports',
                component: () => import(/* webpackChunkName: "Reports" */ '@/views/dashboard/Reports.vue'),
                meta: {
                    requiresAuth: true,
                    requiresAdmin: true
                },
                childs: []
            },
            {
                path: ROUTE_PATHS.USERS_MANAGEMENT,
                name: 'UsersManagement',
                component: () => import(/* webpackChunkName: "Users" */ '@/views/dashboard/Users.vue'),
                meta: {
                    requiresAuth: true,
                    requiresAdmin: true
                },
                childs: []
            },
            {
                path: ROUTE_PATHS.PRODUCT_SCORE,
                name: 'ProductScore',
                component: () => import(/* webpackChunkName: "ProductScore" */ '@/views/dashboard/ProductScore.vue'),
                meta: {
                    requiresAuth: true,
                    requiresAdmin: true
                },
                childs: []
            },
            {
                path: ROUTE_PATHS.RESULT_MANAGEMENT,
                name: 'Results',
                component: () => import(/* webpackChunkName: "Results" */ '@/views/dashboard/Results.vue'),
                meta: {
                    requiresAuth: true,
                    requiresAdmin: true
                },
                childs: []
            },
            {
                path: ROUTE_PATHS.ORDERS,
                name: 'Orders',
                component: () => import(/* webpackChunkName: "Results" */ '@/views/dashboard/Orders.vue'),
                meta: {
                    requiresAuth: true,
                    requiresAdmin: true
                },
                childs: []
            },
            {
                path: ROUTE_PATHS.PACKAGING,
                name: 'Packaging',
                component: () => import(/* webpackChunkName: "Results" */ '@/views/dashboard/Packaging.vue'),
                meta: {
                    requiresAuth: true,
                    requiresAdmin: false
                },
                childs: []
            }

        ]
    },
    {
        path: ROUTE_PATHS.LOGIN,
        name: 'Login',
        component: () => import(/* webpackChunkName: "login" */ '@/views/Login.vue')
    }
]


const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from, next) => {
    const requiresAuth = to.matched.some(x => x.meta.requiresAuth)
    const requiresAdmin = to.matched.some(x => x.meta.requiresAdmin)

    if (requiresAuth && !auth.currentUser) {
        next(ROUTE_PATHS.LOGIN)
    } else {
        console.log(requiresAuth, requiresAdmin, auth.currentUser ? auth.currentUser.email : '-')
        if (requiresAdmin && auth.currentUser && auth.currentUser.email === 'zydrunegr@gmail.com') {
            next(ROUTE_PATHS.LOGIN)
        } else {
            next()
        }
    }
})

export {router, ROUTE_PATHS}